import { publishOffer, unpublishOffer } from "_graphql/visal/mutations/publish-offer";
import { useCallback, useState } from "react";

import { PopUp } from "components";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";

export default function PublishUnpublishOfferContainer({
  open,
  setOpen,
  offerId,
  isPublished,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  offerId: string;
  isPublished: boolean;
  refetch?: () => void;
}) {
  // const { employee } = useCurrentUser();
  const [loading, setLoading] = useState(false);

  const [publishOfferMutation, { loading: publishing }] = useMutation(publishOffer, {
    // client: placeItClient,
    onCompleted: () => {
      toast.success("Offer published successfully");
      if (refetch) refetch();
      setOpen(false);
    },
    onError: (error) => {
      toast.error("Failed to publish offer");
    },
  });

  const [unpublishOfferMutation, { loading: unpublishing }] = useMutation(unpublishOffer, {
    // client: placeItClient,
    onCompleted: () => {
      toast.success("Offer unpublished successfully");
      if (refetch) refetch();
      setOpen(false);
    },
    onError: (error) => {
      toast.error("Failed to unpublish offer");
    },
  });

  const handleSubmit = useCallback(async () => {
    try {
      setLoading(true);

      const input = {
        offer_id: offerId,
      };

      if (isPublished) {
        await unpublishOfferMutation({
          variables: { input },
        });
      } else {
        await publishOfferMutation({
          variables: { input },
        });
      }
    } catch (error) {
      toast.error(`Failed to ${isPublished ? "unpublish" : "publish"} offer`);
    } finally {
      setLoading(false);
    }
  }, [isPublished, offerId, publishOfferMutation, unpublishOfferMutation]);

  const form = useFormik({
    initialValues: {},
    onSubmit: handleSubmit,
  });

  const renderActions = useCallback(
    () => (
      <>
        <button
          type="button"
          disabled={publishing || unpublishing}
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-yellow-600 text-base font-medium text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto sm:text-sm"
          onClick={handleSubmit}
        >
          {publishing || unpublishing ? "Processing..." : isPublished ? "Unpublish" : "Publish"}
        </button>
      </>
    ),
    [form.handleSubmit, isPublished]
  );

  return (
    <PopUp
      variant="warning"
      title={`Are you sure you want to ${isPublished ? "unpublish" : "publish"
        } this offer?`}
      description={
        isPublished
          ? "Unpublishing this offer will make it unavailable to reinsurers."
          : "Publishing this offer will make it available to reinsurers."
      }
      open={open}
      setOpen={setOpen}
      renderActions={renderActions}
    />
  );
}
